var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useRef, useState } from 'react';
import { Modal } from './Modal';
import { MODAL_VIEW } from "./types";
export function useModal(_a) {
    var initialActiveState = _a.initialActiveState, render = _a.render, _b = _a.view, view = _b === void 0 ? MODAL_VIEW.dialog : _b, overlayColor = _a.overlayColor, onDidClose = _a.onDidClose, mainContentId = _a.mainContentId, rest = __rest(_a, ["initialActiveState", "render", "view", "overlayColor", "onDidClose", "mainContentId"]);
    var dataRef = useRef();
    var _c = useState(!!initialActiveState), isActive = _c[0], setShowState = _c[1];
    var deactivate = useCallback(function () {
        dataRef.current = undefined;
        setShowState(false);
    }, []);
    var activate = useCallback(function (data) {
        dataRef.current = data;
        setShowState(true);
    }, []);
    var toggle = function (data) {
        isActive ? deactivate() : activate(data);
    };
    var body = (React.createElement(Modal, { mainContentId: mainContentId, isShown: isActive, enterTimeout: 0, exitTimeout: 0, onRequestClose: deactivate, onDidClose: onDidClose, view: view, overlayColor: overlayColor, render: function (_a) {
            var hide = _a.hide;
            return (render({
                deactivate: hide,
                onRequestClose: hide,
                activate: activate,
                toggle: toggle,
                data: dataRef.current,
                isActive: isActive
            }) || null);
        }, "data-selector-id": rest['data-selector-id'] }));
    return [body, { deactivate: deactivate, activate: activate, toggle: toggle, isActive: isActive }];
}
//# sourceMappingURL=modalHook.js.map